import { render, staticRenderFns } from "./VitalsPanel.vue?vue&type=template&id=17ca93fb"
import script from "./VitalsPanel.vue?vue&type=script&lang=js"
export * from "./VitalsPanel.vue?vue&type=script&lang=js"
import style0 from "./VitalsPanel.vue?vue&type=style&index=0&id=17ca93fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports